module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-upload-area"
  }, [_c('label', {
    class: {
      empty: _vm.file ? false : true
    },
    style: ({
      backgroundImage: 'url(' + _vm.image + ')'
    }),
    attrs: {
      "for": "upload"
    },
    on: {
      "drop": _vm.drop,
      "dragover": _vm.dropAllow
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "plekan-file-information"
  }), _vm._v(" "), _c('input', {
    attrs: {
      "id": "upload",
      "type": "file"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62dce899"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/fileUpload.vue
// module id = 115
// module chunks = 0